// extracted by mini-css-extract-plugin
export default {"heartFollow":"HeartButton-module__heartFollow___V6kSj","heart":"HeartButton-module__heart___DzUrq"};